import type { Guide } from '../types';

/** S-20.10-03 — „Obsadź” u planisty wyszarzony z podpowiedzią (scenariusz e2e 13, BR-FTL-01). */
export const guide: Guide = {
  flagKey: 'assignButtonForPlanner',
  title: '„Obsadź” u planisty wyszarzony z podpowiedzią',
  whatItDoes:
    'Planista FTL nie obsadza — obsadza Team Leader i administratorzy. Zamiast ukrytego przycisku planista widzi „Obsadź” nieaktywny, z podpowiedzią „Obsadza Team Leader” — przy rekomendowanych pojazdach, na karcie zlecenia i w wierszu banku. Planista dodaje warianty, a decyzję podejmuje Team Leader.',
  audience: ['planista FTL'],
  presentationItems: ['S-20.10-03'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: {
        description: 'zlecenie do obsadzenia z wariantami',
        listPath: '/user-offers',
        listFilter: { forklift: 'hide', dzial: 'FTL' },
      },
      target: 'assign-team-leader-only',
      mockupTestId: 'ftl-zlecenie-obsadz-blokada',
      title: '„Obsadź” nieaktywny',
      description:
        'Przycisk jest widoczny, ale nieaktywny — po najechaniu podpowiedź mówi, że obsadza Team Leader. Twój wybór pokazujesz wariantem.',
      action: 'Najedź na „Obsadź”, a pojazd wskaż przyciskiem „Wariant”.',
      recorder: { account: 'ftl', demo: { kind: 'order', number: 'DEMO/2026/10/V01' } },
    },
  ],
};
